import { API, graphqlOperation} from "aws-amplify"
import { createOutbox } from "../graphql/mutations"

//this.$store.state.operatingOffice.OfficeID
export default {
    methods: {
        logging: async function(level, officeID, message, detail) {
          try {
            let item = {}
            item.Type = level
            item.Body = message
            item.From = officeID
            item.Subject = detail

            const _createOutbox = await API.graphql(graphqlOperation(createOutbox, {input: item}))
            console.log('success', _createOutbox)

          } catch (error) {
            console.log('logging error: ', error)
          }

        },

          

    }
}